import messages from './header-translations';
import * as $ from 'jquery';

export default {
    name: 'instamapsHeader',
    i18n: {
        messages,
    },
    data: function () {
        return {
            isMobileMenuShown: false, 
        };
    },
    props: {
		isInIframe: { type: Boolean },
		isUserLogged: { type: Boolean },
		logo: { type: String },
		url : { type: String },
		mapName: { type: String},
		viewerParams: { type: Object },
		contact: { type: String },
    },
    methods: {
		showHeader: function() {
			return this.viewerParams.topbar === undefined || this.viewerParams.topbar;
		},
		hasLogo: function() {
			return (this.logo && this.logo != "" && this.logo.indexOf("blank.gif") === -1  && this.logo.indexOf("instamaps-v2-logo-flat.png") === -1 && this.logo.indexOf("mapa.html")===-1);
		},
		getLogo: function () {
			if (this.logo && this.logo !== "" && this.logo.indexOf("blank.gif") === -1 && this.logo.indexOf("instamaps-v2-logo-flat.png") === -1 
			&& this.logo.indexOf("logo_EPM") === -1 && this.logo.indexOf("mapa.html")===-1) {				
				return "/logos/" + this.logo;
            }
            else if (this.logo && this.logo !== "" && this.logo.indexOf("logo_EPM") !== -1) {
                return "/static/img/logo_EPM.jpg";
			}
			else if (this.logo && this.logo !== "" && this.logo.indexOf("mapa.html") !== -1) {
				return "";
			}
            else {
                return "/static/img/instamaps-v2-logo-flat.png";
            }
		},
		getLogoStyle: function () {
			if (this.logo && this.logo !== "" && this.logo.indexOf("blank.gif") === -1  && this.logo.indexOf("instamaps-v2-logo-flat.png") === -1 && this.logo.indexOf("logo_EPM") === -1) {
                return "height: 50px";
            }
            else if (this.logo && this.logo !== "" && this.logo.indexOf("logo_EPM") !== -1) {
                return "height: 60px";
            }
            else {		
                return "height: 20px";
            }
		},
		getURL: function () {
			if(this.url && this.url != "") {
				return this.url;
			} else {
				return "https://www.instamaps.cat";
			}
        },
        getMailToURL: function(){
            if (this.contact == "instamaps@icgc.cat"){
                var urlForm="https://forms.office.com/r/gNusfQ0Vit";
                return urlForm;
            }
            else {
                var mailTo = "mailto:"+this.contact;
                mailTo += "?subject=Url del visor: "+ $(location).attr('href')+"&body=Url del visor: "+ $(location).attr('href');
                return mailTo;
            }
            
        },
        getMapName: function() {
            return (this.mapName && this.mapName != "") ? this.mapName : "";
        },
        showLanguageSelector: function () {
            $('#language-selector').addClass('show-language-menu');
        },
        hideLanguageSelector: function () {
            $('#language-selector').removeClass('show-language-menu');
        },
        toggleLanguageSelector: function (event) {
            if (event.target.className !== 'language-menu-item') {
                ($('#language-selector').hasClass('show-language-menu')) ? this.hideLanguageSelector(): this.showLanguageSelector();
            }
		},
		showVideoSelector: function () {
            $('#video-selector').addClass('show-video-menu');
        },
        hideVideoSelector: function () {
             $('#video-selector').removeClass('show-video-menu');
        },
        toggleVideoSelector: function (event) {
            if (event.target.className !== 'video-menu-item') {
                ($('#video-selector').hasClass('show-video-menu'))
                    ? this.hideVideoSelector()
                    : this.showVideoSelector();
            }
        },
		showPerfilSelector: function () {
            $('#perfil-selector').addClass('show-perfil-menu');
        },
        hidePerfilSelector: function () {
            $('#perfil-selector').removeClass('show-perfil-menu');
        },
        togglePerfilSelector: function (event){
            if (event.target.className !== 'perfil-menu-item') {
                ($('#perfil-selector').hasClass('show-perfil-menu'))
                    ? this.hidePerfilSelector()
                    : this.showPerfilSelector();
            }
        },
        langChange: function (lang) {
            this.hideLanguageSelector();
            this.$emit('langchanged', lang);
        },
        toggle: function () {
            this.isMobileMenuShown = !this.isMobileMenuShown;
            this.$emit('mobileMenuPressed', this.isMobileMenuShown);
		},
		logout: function(){
            this.$emit('logout');
        },
        toProfile: function(){
            this.$emit('toProfile');
        },
        callToExternalJs: function () {
            // eslint-disable-next-line no-undef 
            _3D();
		},
		handleResize: function () {
			var headerPadding = 18;
			var namePadding = 18;
			var leftMenuMargin = 18;
			var minNameWidth = 128;
			var miniButtonWidth = 960;

			var documentWidth = document.documentElement.clientWidth;
			var options = document.getElementById("menu-top");
			var optionsWidth = 0;
			if(options)
				optionsWidth = options.offsetWidth;

			if(documentWidth <= miniButtonWidth) {
				optionsWidth = document.getElementsByClassName("menu-button")[0].offsetWidth;
			}

			var logos = document.getElementsByClassName("logo");
			var logoWidth = 0;
			if(logos.length !== 0)
				logoWidth = logos[0].offsetWidth;
			
			var names = document.getElementsByClassName("map-name");
			if(names.length !== 0) {
				var nameWidth = documentWidth - optionsWidth - logoWidth - headerPadding - namePadding - leftMenuMargin;
				nameWidth = Math.max(nameWidth, minNameWidth);
				names[0].style.width = `${nameWidth}px`;
			}

			this.moveCookiesBanner();

		},
		moveCookiesBanner: function () {
			var footerControls = document.getElementsByClassName("footer-controls-wrapper")[0];
			var cookies = document.getElementById("cookies-footer");
			cookies.style.right = `${footerControls.offsetWidth}px`;
		}
    },
    mounted() {
		window.addEventListener('resize', this.handleResize)
	},
	updated() {
		var self = this;
		var logos = document.getElementsByClassName("logo");
		if(logos.length !== 0) {

			var logo = logos[0];
			logo.onload = function() {
				self.handleResize();
			}
		} else {
			self.handleResize();
		}
		
	},
	beforeDestroy() {
		window.removeEventListener('resize', this.handleResize)
	}
};



// WEBPACK FOOTER //
// ./src/shared/components/header/header.js